



































import $ from 'jquery'
import 'bootstrap-select';
import { Component, Vue, Prop } from 'vue-property-decorator'
import { ValidationProvider } from 'vee-validate'

import { localize } from "vee-validate"

@Component({
  components: {
    ValidationProvider
  },
  name: 'SelectPicker'
})
export default class SelectPicker extends Vue {
  @Prop({required: false, default: undefined}) vid!: string
  @Prop({required: true, default: ""}) name!: string
  @Prop({required: false, default: ""}) label!: string
  @Prop({required: false, default: ""}) rules!: string[] | object[]
  @Prop({required: false, default: false}) disabled!: boolean
  @Prop({required: true}) title!: string
  @Prop({required: true}) value!: string
  @Prop({required: false, default: 10}) size!: number

  get innerValue(): string {
    return this.value
  }

  set innerValue(value: string) {
    this.$emit('input', value)
  }

  updated(): void {
      $(this.$el).find('select').selectpicker('refresh')
  }

  mounted(): void {
      $(this.$el).find('select').selectpicker()
  }

  created(): void {

    // Validation custom messages - localise the names.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const names: any = {}

    names[this.name] = this.label || this.name

    localize({
      en: {
        names
      },
    })
  }
}
